import LabelClass from '@arcgis/core/layers/support/LabelClass';
import CIMSymbol from '@arcgis/core/symbols/CIMSymbol';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';

// Color Definitions based on _color-vars.scss
export const netsLegendBlue: string = '#1817c8'; // --nets-legend-blue
export const netsLegendLightBlue: string = '#4DC8F5'; // --nets-legend-light-blue
export const netsLegendPink: string = '#ff01df'; // --nets-legend-pink
export const netsLegendOrange: string = '#F0BF4C'; // --nets-legend-orange
export const netsLegendLightGreen: string = '#12da04'; // --nets-legend-light-green
export const netsLegendGreen: string = '#008000'; // --nets-legend-green
export const netsLegendDarkRed: string = '#b11a2c'; // --nets-legend-dark-red
export const netsLegendBlack: string = '#000000' //--nets-legend-black

export const reachLineSymbol = {
  designLineSymbol: new SimpleLineSymbol({ color: 'black', width: 2 }),
  invalidLineSymbol: new SimpleLineSymbol({ color: 'red', width: 3 }),
  // ai design experimental code
  /* istanbul ignore next */
  designLineGraySymbol: new SimpleLineSymbol({ color: 'gray', width: 2 }),
};

export const channelLineSymbol = {
  designLineSymbol: new SimpleLineSymbol({ color: netsLegendBlue, width: 2 }),
  invalidLineSymbol: new SimpleLineSymbol({ color: 'red', width: 3 }),
  waterLevelSymbol: new SimpleLineSymbol({ color: netsLegendLightBlue, width: 2 }),
  settledTerraceSymbol: new SimpleLineSymbol({ color: 'black', width: 2, style: 'short-dash' }),
};

export const reachStationSymbol = {
  reachStationSymbol: new SimpleMarkerSymbol({ color: 'black', size: 7, style: 'circle', outline: { width: 0 } }),
  editableStationSymbol: new SimpleMarkerSymbol({ color: '#FF8607', size: 7, style: 'circle', outline: { width: 0 } }),
  invisibleSymbol: new SimpleMarkerSymbol({ color: [0, 0, 0, 0], outline: undefined }),
  // ai design experimental code
  /* istanbul ignore next */
  reachStationGraySymbol: new SimpleMarkerSymbol({ color: 'gray', size: 7, style: 'circle', outline: { width: 0 } }),
}

export const channelStationSymbol = {
  reachStationSymbol: new SimpleMarkerSymbol({ color: netsLegendBlue, size: 7, style: 'circle', outline: { width: 0 } }),
  highlightedStationSymbol: new SimpleMarkerSymbol({ color: 'cyan', size: 8, style: 'circle', outline: { width: 0 } }),
}

export const reachHighlightSymbol = new SimpleMarkerSymbol({
  color: [0, 0, 0, 0], // transparent color
  size: 16,
  style: 'square',
  outline: {
    color: '#ff02e5',
    width: 1.6
  },
});

export const pointLabelFields: any = [
  {
    name: 'ObjectID',
    type: 'oid',
  },
  {
    name: 'Station',
    type: 'string',
  }
];

export const pointLabelFields2: any = [
  {
    name: 'ObjectID',
    type: 'oid',
  },
  {
    name: 'StationInfo',
    type: 'string',
  }
];

export const pointLabelClass: LabelClass = new LabelClass({
  symbol: {
    type: 'text',
    color: "black",
    font: {
      family: 'Ubuntu Mono',
      size: 11,
    },
  },
  labelPlacement: "below-center",
  labelPosition: 'curved',
  labelExpressionInfo: {
    expression: '$feature.station',
  },
  deconflictionStrategy: 'none',
});

export const pointLabelClass2: LabelClass = new LabelClass({
  symbol: {
    type: 'text',
    color: "black",
    font: {
      family: 'Ubuntu Mono',
      size: 11,
    },
  },
  labelPlacement: "below-center",
  labelExpressionInfo: {
    expression: '$feature.station',
  },
  deconflictionStrategy: 'static',
  maxScale: 0,
});

export const pointLabelClass3: LabelClass = new LabelClass({
  symbol: {
    type: 'text',
    color: 'black',
    font: {
      family: 'Ubuntu Mono',
      size: 11,
    },
  },
  labelPlacement: "below-right",
  labelExpressionInfo: {
    expression: '$feature.StationInfo',
  },
  deconflictionStrategy: 'none',
  minScale: 2000
});

export const trackerSymbol = new SimpleMarkerSymbol({
  color: "red",
  outline: {
    color: "red",
    width: 2
  },
  style: "x",
  size: 10
});

export const reachStationPointRenderer = {
  type: 'simple',
  symbol: reachStationSymbol.reachStationSymbol,
};

export const editableStationPointRenderer = {
  type: 'simple',
  symbol: reachStationSymbol.editableStationSymbol,
};

export const invisibleRenderer = {
  type: 'simple',
  symbol: reachStationSymbol.invisibleSymbol,
};

export const drainCIMSymbol = new CIMSymbol({
  "data": {
    "type": "CIMSymbolReference",
    "symbol": {
      "type": "CIMPointSymbol",
      "symbolLayers": [
        {
          "type": "CIMVectorMarker",
          "enable": true,
          "colorLocked": true,
          "size": 15.75,
          "frame": {
            "xmin": 0,
            "ymin": 0,
            "xmax": 21,
            "ymax": 21
          },
          "markerGraphics": [
            {
              "type": "CIMMarkerGraphic",
              "geometry": {
                "rings": [
                  [
                    [
                      17,
                      11
                    ],
                    [
                      13,
                      14
                    ],
                    [
                      13,
                      12
                    ],
                    [
                      5,
                      12
                    ],
                    [
                      5,
                      10
                    ],
                    [
                      13,
                      10
                    ],
                    [
                      13,
                      8
                    ],
                    [
                      17,
                      11
                    ]
                  ],
                  [
                    [
                      4,
                      16
                    ],
                    [
                      8,
                      19
                    ],
                    [
                      8,
                      17
                    ],
                    [
                      16,
                      17
                    ],
                    [
                      16,
                      15
                    ],
                    [
                      8,
                      15
                    ],
                    [
                      8,
                      13
                    ],
                    [
                      4,
                      16
                    ]
                  ],
                  [
                    [
                      17,
                      5.56
                    ],
                    [
                      17,
                      4.15
                    ],
                    [
                      16.32,
                      4
                    ],
                    [
                      15.55,
                      4.08
                    ],
                    [
                      14.82,
                      4.33
                    ],
                    [
                      14.13,
                      4.73
                    ],
                    [
                      13.5,
                      5.29
                    ],
                    [
                      12.93,
                      4.74
                    ],
                    [
                      12.26,
                      4.33
                    ],
                    [
                      11.51,
                      4.08
                    ],
                    [
                      10.69,
                      4
                    ],
                    [
                      10.31,
                      4
                    ],
                    [
                      9.49,
                      4.08
                    ],
                    [
                      8.74,
                      4.33
                    ],
                    [
                      8.07,
                      4.74
                    ],
                    [
                      7.5,
                      5.29
                    ],
                    [
                      6.87,
                      4.73
                    ],
                    [
                      6.18,
                      4.33
                    ],
                    [
                      5.45,
                      4.08
                    ],
                    [
                      4.68,
                      4
                    ],
                    [
                      4,
                      4.14
                    ],
                    [
                      4,
                      5.56
                    ],
                    [
                      4.66,
                      5.45
                    ],
                    [
                      5.38,
                      5.55
                    ],
                    [
                      6.09,
                      5.83
                    ],
                    [
                      6.79,
                      6.31
                    ],
                    [
                      7.5,
                      7
                    ],
                    [
                      8.22,
                      6.37
                    ],
                    [
                      8.95,
                      5.91
                    ],
                    [
                      9.67,
                      5.64
                    ],
                    [
                      10.38,
                      5.55
                    ],
                    [
                      10.62,
                      5.55
                    ],
                    [
                      11.33,
                      5.64
                    ],
                    [
                      12.05,
                      5.91
                    ],
                    [
                      12.78,
                      6.37
                    ],
                    [
                      13.5,
                      7
                    ],
                    [
                      14.21,
                      6.31
                    ],
                    [
                      14.91,
                      5.83
                    ],
                    [
                      15.62,
                      5.55
                    ],
                    [
                      16.34,
                      5.45
                    ],
                    [
                      17,
                      5.56
                    ]
                  ]
                ]
              },
              "symbol": {
                "type": "CIMPolygonSymbol",
                "symbolLayers": [
                  {
                    "type": "CIMSolidStroke",
                    "enable": true,
                    "capStyle": "Round",
                    "joinStyle": "Round",
                    "width": 0,
                    "color": [
                      110,
                      110,
                      110,
                      255
                    ]
                  },
                  {
                    "type": "CIMSolidFill",
                    "enable": true,
                    "color": [
                      255,
                      255,
                      255,
                      255
                    ]
                  }
                ]
              },
              textString: '',
              primitiveName: ''
            }
          ],
          "scaleSymbolsProportionally": true,
          "respectFrame": true
        },
        {
          "type": "CIMVectorMarker",
          "enable": true,
          "size": 15.75,
          "frame": {
            "xmin": -5,
            "ymin": -5,
            "xmax": 5,
            "ymax": 5
          },
          "markerGraphics": [
            {
              "type": "CIMMarkerGraphic",
              "geometry": {
                "rings": [
                  [
                    [
                      0,
                      5
                    ],
                    [
                      0.87,
                      4.92
                    ],
                    [
                      1.71,
                      4.7
                    ],
                    [
                      2.5,
                      4.33
                    ],
                    [
                      3.21,
                      3.83
                    ],
                    [
                      3.83,
                      3.21
                    ],
                    [
                      4.33,
                      2.5
                    ],
                    [
                      4.7,
                      1.71
                    ],
                    [
                      4.92,
                      0.87
                    ],
                    [
                      5,
                      0
                    ],
                    [
                      4.92,
                      -0.87
                    ],
                    [
                      4.7,
                      -1.71
                    ],
                    [
                      4.33,
                      -2.5
                    ],
                    [
                      3.83,
                      -3.21
                    ],
                    [
                      3.21,
                      -3.83
                    ],
                    [
                      2.5,
                      -4.33
                    ],
                    [
                      1.71,
                      -4.7
                    ],
                    [
                      0.87,
                      -4.92
                    ],
                    [
                      0,
                      -5
                    ],
                    [
                      -0.87,
                      -4.92
                    ],
                    [
                      -1.71,
                      -4.7
                    ],
                    [
                      -2.5,
                      -4.33
                    ],
                    [
                      -3.21,
                      -3.83
                    ],
                    [
                      -3.83,
                      -3.21
                    ],
                    [
                      -4.33,
                      -2.5
                    ],
                    [
                      -4.7,
                      -1.71
                    ],
                    [
                      -4.92,
                      -0.87
                    ],
                    [
                      -5,
                      0
                    ],
                    [
                      -4.92,
                      0.87
                    ],
                    [
                      -4.7,
                      1.71
                    ],
                    [
                      -4.33,
                      2.5
                    ],
                    [
                      -3.83,
                      3.21
                    ],
                    [
                      -3.21,
                      3.83
                    ],
                    [
                      -2.5,
                      4.33
                    ],
                    [
                      -1.71,
                      4.7
                    ],
                    [
                      -0.87,
                      4.92
                    ],
                    [
                      0,
                      5
                    ]
                  ]
                ]
              },
              "symbol": {
                "type": "CIMPolygonSymbol",
                "symbolLayers": [
                  {
                    "type": "CIMSolidStroke",
                    "effects": [
                      {
                        "type": "CIMGeometricEffectOffset",
                        "method": "Square",
                        "offset": -0.25,
                        "option": "Fast"
                      }
                    ],
                    "enable": true,
                    "colorLocked": true,
                    "capStyle": "Square",
                    "joinStyle": "Miter",
                    "width": 0.5,
                    "color": [
                      0,
                      0,
                      0,
                      64
                    ]
                  },
                  {
                    "type": "CIMSolidFill",
                    "enable": true,
                    "color": [
                      0,
                      122,
                      194,
                      255
                    ]
                  }
                ],
              },
              textString: '',
              primitiveName: ''
            }
          ],
          "scaleSymbolsProportionally": true,
          "respectFrame": true
        }
      ],
      "scaleX": 1,
    }
  }
});

export const blockCIMSymbol = new CIMSymbol({
  "data": {
    "type": "CIMSymbolReference",
    "symbol": {
      "type": "CIMPointSymbol",
      "symbolLayers": [
        {
          "type": "CIMVectorMarker",
          "enable": true,
          "colorLocked": true,
          "size": 15.75,
          "frame": {
            "xmin": 0,
            "ymin": 0,
            "xmax": 21,
            "ymax": 21
          },
          "markerGraphics": [
            {
              "type": "CIMMarkerGraphic",
              "geometry": {
                "rings": [
                  [
                    [
                      18,
                      16
                    ],
                    [
                      18,
                      6
                    ],
                    [
                      3,
                      6
                    ],
                    [
                      3,
                      16
                    ],
                    [
                      18,
                      16
                    ]
                  ],
                  [
                    [
                      4,
                      7
                    ],
                    [
                      6,
                      7
                    ],
                    [
                      6,
                      9
                    ],
                    [
                      4,
                      9
                    ],
                    [
                      4,
                      7
                    ]
                  ],
                  [
                    [
                      7,
                      7
                    ],
                    [
                      12,
                      7
                    ],
                    [
                      12,
                      9
                    ],
                    [
                      7,
                      9
                    ],
                    [
                      7,
                      7
                    ]
                  ],
                  [
                    [
                      13,
                      7
                    ],
                    [
                      17,
                      7
                    ],
                    [
                      17,
                      9
                    ],
                    [
                      13,
                      9
                    ],
                    [
                      13,
                      7
                    ]
                  ],
                  [
                    [
                      4,
                      10
                    ],
                    [
                      8,
                      10
                    ],
                    [
                      8,
                      12
                    ],
                    [
                      4,
                      12
                    ],
                    [
                      4,
                      10
                    ]
                  ],
                  [
                    [
                      9,
                      10
                    ],
                    [
                      14,
                      10
                    ],
                    [
                      14,
                      12
                    ],
                    [
                      9,
                      12
                    ],
                    [
                      9,
                      10
                    ]
                  ],
                  [
                    [
                      15,
                      10
                    ],
                    [
                      17,
                      10
                    ],
                    [
                      17,
                      12
                    ],
                    [
                      15,
                      12
                    ],
                    [
                      15,
                      10
                    ]
                  ],
                  [
                    [
                      4,
                      13
                    ],
                    [
                      6,
                      13
                    ],
                    [
                      6,
                      15
                    ],
                    [
                      4,
                      15
                    ],
                    [
                      4,
                      13
                    ]
                  ],
                  [
                    [
                      7,
                      13
                    ],
                    [
                      12,
                      13
                    ],
                    [
                      12,
                      15
                    ],
                    [
                      7,
                      15
                    ],
                    [
                      7,
                      13
                    ]
                  ],
                  [
                    [
                      13,
                      13
                    ],
                    [
                      17,
                      13
                    ],
                    [
                      17,
                      15
                    ],
                    [
                      13,
                      15
                    ],
                    [
                      13,
                      13
                    ]
                  ]
                ]
              },
              "symbol": {
                "type": "CIMPolygonSymbol",
                "symbolLayers": [
                  {
                    "type": "CIMSolidStroke",
                    "enable": true,
                    "capStyle": "Round",
                    "joinStyle": "Round",
                    "width": 0,
                    "color": [
                      88,
                      89,
                      91,
                      255
                    ]
                  },
                  {
                    "type": "CIMSolidFill",
                    "enable": true,
                    "color": [
                      255,
                      255,
                      255,
                      255
                    ]
                  }
                ],
              },
              textString: '',
              primitiveName: ''
            }
          ],
          "scaleSymbolsProportionally": true,
          "respectFrame": true
        },
        {
          "type": "CIMVectorMarker",
          "enable": true,
          "size": 15.75,
          "frame": {
            "xmin": -5,
            "ymin": -5,
            "xmax": 5,
            "ymax": 5
          },
          "markerGraphics": [
            {
              "type": "CIMMarkerGraphic",
              "geometry": {
                "rings": [
                  [
                    [
                      0,
                      5
                    ],
                    [
                      0.87,
                      4.92
                    ],
                    [
                      1.71,
                      4.7
                    ],
                    [
                      2.5,
                      4.33
                    ],
                    [
                      3.21,
                      3.83
                    ],
                    [
                      3.83,
                      3.21
                    ],
                    [
                      4.33,
                      2.5
                    ],
                    [
                      4.7,
                      1.71
                    ],
                    [
                      4.92,
                      0.87
                    ],
                    [
                      5,
                      0
                    ],
                    [
                      4.92,
                      -0.87
                    ],
                    [
                      4.7,
                      -1.71
                    ],
                    [
                      4.33,
                      -2.5
                    ],
                    [
                      3.83,
                      -3.21
                    ],
                    [
                      3.21,
                      -3.83
                    ],
                    [
                      2.5,
                      -4.33
                    ],
                    [
                      1.71,
                      -4.7
                    ],
                    [
                      0.87,
                      -4.92
                    ],
                    [
                      0,
                      -5
                    ],
                    [
                      -0.87,
                      -4.92
                    ],
                    [
                      -1.71,
                      -4.7
                    ],
                    [
                      -2.5,
                      -4.33
                    ],
                    [
                      -3.21,
                      -3.83
                    ],
                    [
                      -3.83,
                      -3.21
                    ],
                    [
                      -4.33,
                      -2.5
                    ],
                    [
                      -4.7,
                      -1.71
                    ],
                    [
                      -4.92,
                      -0.87
                    ],
                    [
                      -5,
                      0
                    ],
                    [
                      -4.92,
                      0.87
                    ],
                    [
                      -4.7,
                      1.71
                    ],
                    [
                      -4.33,
                      2.5
                    ],
                    [
                      -3.83,
                      3.21
                    ],
                    [
                      -3.21,
                      3.83
                    ],
                    [
                      -2.5,
                      4.33
                    ],
                    [
                      -1.71,
                      4.7
                    ],
                    [
                      -0.87,
                      4.92
                    ],
                    [
                      0,
                      5
                    ]
                  ]
                ]
              },
              "symbol": {
                "type": "CIMPolygonSymbol",
                "symbolLayers": [
                  {
                    "type": "CIMSolidStroke",
                    "effects": [
                      {
                        "type": "CIMGeometricEffectOffset",
                        "method": "Square",
                        "offset": -0.25,
                        "option": "Fast"
                      }
                    ],
                    "enable": true,
                    "colorLocked": true,
                    "capStyle": "Square",
                    "joinStyle": "Miter",
                    "width": 0.5,
                    "color": [
                      0,
                      0,
                      0,
                      64
                    ]
                  },
                  {
                    "type": "CIMSolidFill",
                    "enable": true,
                    "color": [
                      0,
                      122,
                      194,
                      255
                    ]
                  }
                ],
              },
              textString: '',
              primitiveName: ''
            }
          ],
          "scaleSymbolsProportionally": true,
          "respectFrame": true
        }
      ],
      "scaleX": 1,
    }
  }
});

// ai design experimental code
/* istanbul ignore next */
export const aiReachMarkerRed = new SimpleMarkerSymbol({
  color: [0, 0, 0, 0], // transparent color
  size: 16,
  style: 'square',
  outline: {
    color: netsLegendPink,
    width: 2
  },
});

/* istanbul ignore next */
export const aiReachMarkerGreen = new SimpleMarkerSymbol({
  color: [0, 0, 0, 0], // transparent color
  size: 16,
  style: 'square',
  outline: {
    color: netsLegendLightGreen,
    width: 2
  },
});

/* istanbul ignore next */
export const aiReachMarkerBlue = new SimpleMarkerSymbol({
  color: [0, 0, 0, 0], // transparent color
  size: 16,
  style: 'square',
  outline: {
    color: netsLegendLightBlue,
    width: 2
  },
});

/* istanbul ignore next */
export const aiReachMarkerViolet = new SimpleMarkerSymbol({
  color: [0, 0, 0, 0], // transparent color
  size: 16,
  style: 'square',
  outline: {
    color: "blue",
    width: 2
  },
});

/* istanbul ignore next */
export function createAiActionArrow(direction: number, color: number[], offsetX = 0, offsetY = 0) {
  return {
    type: "cim",
    data: {
      type: "CIMSymbolReference",
      symbol: {
        type: "CIMPointSymbol",
        symbolLayers: [{
          type: "CIMVectorMarker",
          enable: true,
          size: 20,
          frame: { xmin: -10, ymin: -10, xmax: 10, ymax: 10 },
          markerGraphics: [{
            type: "CIMMarkerGraphic",
            geometry: {
              rings: [[
                [0, 10],
                [4, 0],
                [2, 0],
                [2, -10],
                [-2, -10],
                [-2, 0],
                [-4, 0],
                [0, 10]
              ]]
            },
            symbol: {
              type: "CIMPolygonSymbol",
              symbolLayers: [{
                type: "CIMSolidFill",
                enable: true,
                color,
              }]
            }
          }],
          offsetX,
          offsetY,
          rotation: direction,
          rotationType: "geographic"
        }]
      }
    }
  } as any;
}

/* istanbul ignore next */
export function createAiActionLabel(text: string, colorArray: number[], yoffset: number, xoffset = 0) {
  return {
    type: "text",
    text,
    color: `rgba(${colorArray[0]}, ${colorArray[1]}, ${colorArray[2]}, ${colorArray[3] / 255})`,
    font: {
      size: 13,
      family: "Consolas"
    },
    haloColor: "white",
    haloSize: "1px",
    xoffset,
    yoffset
  };
}
// End: ai design experimental code